'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _Checkbox = require('../../components/Checkbox/Checkbox');

var _Captcha = require('../../helpers/Captcha');

var _DefaultString = require('../../helpers/DefaultString');

var _Product = require('../../helpers/Product');

var _Router = require('../../helpers/Router');

var _LinkAccount = require('../../helpers/LinkAccount');

var _SignUpOptions = require('./SignUpOptions.scss');

var _SignUpOptions2 = _interopRequireDefault(_SignUpOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NB_DAY_FREE_TRIAL = 7;

var SignUpOptions = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    captcha: state.captcha
  };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SignUpOptions, _Component);

  function SignUpOptions() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SignUpOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SignUpOptions.__proto__ || (0, _getPrototypeOf2.default)(SignUpOptions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      captchaError: false
    }, _this.getTitle = function () {
      var formatMessage = _this.props.intl.formatMessage;

      var title = void 0;
      switch (_this.props.auth.productName) {
        case _Product.PRODUCT_NAMES.Classica:
          title = null;
          break;
        case _Product.PRODUCT_NAMES.Qello:
          title = _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.CreateAnAccount);
          break;
        default:
          title = _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.SignUpTitle, {
            values: { product: formatMessage((0, _Product.getProductName)(_this.props.auth.realm, _this.props.auth.productName, _this.props.auth.clientId)) }
          }));
      }
      return _react2.default.createElement(
        'div',
        { className: _SignUpOptions2.default.title },
        title
      );
    }, _this.getMessage = function () {
      var message = null;
      switch (_this.props.auth.productName) {
        case _Product.PRODUCT_NAMES.Classica:
          message = _react2.default.createElement(
            'div',
            { className: _SignUpOptions2.default.message },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.CreateAnAccount)
          );
          break;
        default:
      }
      return message;
    }, _this.editCaptchaError = function (captchaError) {
      _this.setState({ captchaError: captchaError });
    }, _this.signUpEmail = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.SignUpEmail));
    }, _this.navLoginOptions = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.LoginOptions));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SignUpOptions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _LinkAccount.setProviderInStorageForLinkAccount)(this.props.auth);

      (0, _LinkAccount.setOldSessionIdInStorage)(this.props.auth.realm);
    }
  }, {
    key: 'render',
    value: function render() {
      var email = (0, _Product.getMailLogo)(this.props.auth.productName);
      var hasCaptcha = this.props.captcha.needCaptcha;
      var title = this.getTitle();
      var message = this.getMessage();
      var isButtonCenter = (0, _Product.isIconButtonCenter)(this.props.auth.productName);

      return _react2.default.createElement(
        'div',
        { className: _SignUpOptions2.default.signUpOptions },
        title,
        message,
        _react2.default.createElement(_components.TermsAndPrivacy, { className: _SignUpOptions2.default.terms, theme: _Checkbox.CheckboxTheme.APP_COLOR, intl: this.props.intl, auth: this.props.auth }),
        _react2.default.createElement(_components.BaseButton, { className: _SignUpOptions2.default.emailButton, onClick: this.signUpEmail, buttonString: _DefaultString.translations.SignUpWithEmail, icon: email, isCenter: isButtonCenter }),
        _react2.default.createElement(_components.SocialLoginButtons, null),
        _react2.default.createElement(_components.Captcha, { error: this.state.captchaError, editCaptchaError: this.editCaptchaError, captchaTypeRequired: SignUpOptions.beCalls }),
        _react2.default.createElement(
          'div',
          { className: _SignUpOptions2.default.already + (hasCaptcha ? ' ' + _SignUpOptions2.default.needCaptcha : '') },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.AlreadyAccount),
          _react2.default.createElement(
            'span',
            { className: _SignUpOptions2.default.login, onClick: this.navLoginOptions },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Login)
          )
        )
      );
    }
  }]);
  return SignUpOptions;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  captcha: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _class2.beCalls = [_Captcha.CaptchaCallNames.FacebookLogin], _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(SignUpOptions);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SignUpOptions/SignUpOptions.js
// module id = 2021
// module chunks = 0